import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { GET, POST } from "../../helpers/apiHelper";
import {
  PROGRESS_ROSTER_IMPORT,
  progressRosterImportSuccess,
  progressRosterImportError,
  CANCEL_ROSTER_IMPORT,
  cancelRosterImportSuccess,
  cancelRosterImportError,
} from "./actions";
import { unauthorizeUser } from "../../helpers/utility";

const loadProgressRosterImportAsync = async (id) => GET(`/roster-import/status/${id}`);
const cancelRosterImportAsync = async (jobId) => GET(`/roster-import/cancel/${jobId}`);

/**
 * Saga to track roster import process progress.
 * @param {Object} action - Redux action.
 * @param {Object} action.payload - Payload containing job ID.
 */
function* loadProcessRosterImport({ payload }) {
  try {
    const response = yield call(loadProgressRosterImportAsync, payload.id);
    yield put(progressRosterImportSuccess(response));
  } catch (error) {
    // Handle CORS or 502 errors
    if (error instanceof TypeError || (error?.response && error?.response?.status === 502)) {
      yield put(progressRosterImportError({ progress: 0 }));
      return;
    } else if (error.message === "Network Error") {
      yield put(progressRosterImportError({ progress: 0 }));
      return;
    }
    yield call(unauthorizeUser(error));
    yield put(progressRosterImportError(error));
  }
}

export function* watchProgressRosterImport() {
  yield takeEvery(PROGRESS_ROSTER_IMPORT, loadProcessRosterImport);
}

export default function* rootSaga() {
  yield all([
    fork(watchProgressRosterImport),
    fork(watchCancelRosterImport),
  ]);
}

function* performCancelRosterImport({ payload }) {
  try {
    const { jobId, history } = payload;
    const response = yield call(cancelRosterImportAsync, jobId);
    yield put(cancelRosterImportSuccess(response));
    // Immediately refresh job status to reflect failed state on the same page
    yield put({ type: PROGRESS_ROSTER_IMPORT, payload: { id: jobId, loading: true } });
  } catch (error) {
    yield call(unauthorizeUser, error);
    yield put(cancelRosterImportError(error));
  }
}

export function* watchCancelRosterImport() {
  yield takeEvery(CANCEL_ROSTER_IMPORT, performCancelRosterImport);
}

// no-op
